import styled from 'styled-components';

import { Collapse as AntdCollapse } from 'antd';

export const Collapse = styled(AntdCollapse)`
  background-color: ${({ theme }) => theme.colors.background.primary};

  .ant-collapse-content > .ant-collapse-content-box {
    padding: 0;
  }

  .ant-collapse-borderless > .ant-collapse-item > .ant-collapse-content > .ant-collapse-content-box {
    padding-top: 0;
  }

  .ant-collapse-item {
    padding: 26px 29px;
    border-bottom: 0 !important;
  }

  .ant-collapse-item:not(:last-child) {
    border-bottom: 0.7px solid ${({ theme }) => theme.colors.divider.primary} !important;
  }

  .ant-collapse-header {
    color: ${({ theme }) => theme.colors.element.primary};
    font-weight: 600;
    font-size: 20px;
    line-height: 35px;

    display: flex;
    flex-direction: row-reverse;
    justify-content: flex-end;
    align-items: center;
  }

  .ant-collapse-item > .ant-collapse-header {
    padding: 0 0 12px 0;
  }

  .ant-collapse-header .ant-collapse-arrow {
    position: unset !important;
    transform: none !important;
  }
`;

export const CollapseIconWrapper = styled.div`
  width: 24px;
  height: 24px;

  display: flex !important;
  justify-content: center;
  align-items: center;

  margin-left: 8px;

  > i {
    color: ${({ theme }) => theme.colors.brand.primary};
  }
`;
